import Header from "common/Header";
import { FunctionComponent } from "react";
import { Outlet } from "react-router-dom";
import DashBoardStyles from "./dashboard.module.css";

interface DashboardProps {}

const Dashboard: FunctionComponent<DashboardProps> = () => {
  return (
    <>
      <Header />
      <div className={DashBoardStyles.wrapper_block}>
        <Outlet />
      </div>
    </>
  );
};

export default Dashboard;
